import React from 'react';
import ReactApexChart from 'react-apexcharts';

function DonutChart({ data }) {
  const donutChart = {
    series: data.series,
    options: {
      chart: {
        height: 400, // Increased chart size
        type: 'donut',
        zoom: { enabled: false },
        toolbar: { show: false },
      },
      stroke: { show: false },
      labels: data.label,
      colors: ['#1A2B5C', '#EE1D23'],
      tooltip: {
        enabled: true,
        y: {
          formatter: (value) => `${value}%`,
        },
        custom: ({ seriesIndex, w }) => {
          const value = w.globals.series[seriesIndex];
          const label = w.globals.labels[seriesIndex];

          return `
            <div style="
              background-color: white;
              color: black;
              border-radius: 8px;
              padding: 10px;
              box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
              max-width: 300px; /* Increased width for long labels */
              min-width: 200px; /* Ensure tooltip isn't too narrow */
              word-wrap: break-word;
              overflow-wrap: break-word;
              text-align: center;
              font-size: 14px;">
              <strong style="display: block; white-space: normal;">${label}</strong>
              <span style="font-size: 16px; font-weight: bold;">${value}</span>
            </div>`;
        },
        offsetY: -10,
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: { width: 250 },
          },
        },
      ],
      legend: {
        position: 'bottom',
        fontSize: '14px',
      },
    },
  };

  return (
    <div className="mb-5 transition-transform transform hover:scale-105">
      <ReactApexChart
        series={donutChart.series}
        options={donutChart.options}
        className="rounded-lg bg-white dark:bg-black overflow-hidden"
        type="donut"
        height={400}
      />
    </div>
  );
}

export default DonutChart;
